import React from 'react';
interface MiniMetricProps {
  title: string;
  value: string;
}
export function MiniMetric({
  title,
  value
}: MiniMetricProps) {
  return <div className="bg-gray-50 p-3 rounded-lg" data-id="element-313">
      <div className="text-xs text-gray-500" data-id="element-314">{title}</div>
      <div className="text-sm font-semibold text-gray-900" data-id="element-315">{value}</div>
    </div>;
}